/* istanbul ignore next */
const ACTIONS = {
    CONFIRM_BRAND: 'CONFIRM_BRAND',
    CONFIRM_ACCOUNT: 'CONFIRM_ACCOUNT',
    MULTIPLE_ACCOUNTS_SELECTION_ERROR: 'MULTIPLE_ACCOUNTS_SELECTION_ERROR',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    confirmAccount(confirmAccountDetails) {
        return {
            type: ACTIONS.CONFIRM_ACCOUNT,
            payload: {
                confirmAccountDetails
            }
        };
    },
    alertError(errorKey) {
        return {
            type: ACTIONS.MULTIPLE_ACCOUNTS_SELECTION_ERROR,
            payload: {
                errorKey
            }
        };
    },
    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
